var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app"},[_c('layout-nav'),(!_vm.isHome)?_c('layout-banner'):_vm._e(),(!_vm.isHome)?_c('layout-breadcrumb'):_vm._e(),_c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_c('layout-bottom'),_c('layout-back-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }